import React, { useEffect, useState } from 'react';
import Breadcumb from '../Layouts/Breadcumb';
import { Grid, TextField } from '@mui/material';
import axios from 'axios';
import { Constants } from '../endPoints';
import Swal from 'sweetalert2';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { jwtDecode } from 'jwt-decode'; // Make sure it's installed

export default function Contact() {
    const [initialValues, setInitialValues] = useState({
        name: '',
        email: '',
        phone_number: '',
        message: '',
    });

    // Yup validation schema
    const ContactSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        phone_number: Yup.string()
            .matches(/^\d{10,15}$/, 'Phone number must be 10 to 15 digits')
            .nullable(),
        message: Yup.string().required('Message is required'),
    });

    // Auto-fill from token
    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token) {
            const decoded = jwtDecode(token);
            const userId = decoded.id;

            const fetchUserDetails = async () => {
                try {
                    const res = await axios.get(`${Constants.userInfoById}/${userId}`);
                    if (res.data.status === 1) {
                        const user = res.data.data;
                        const name = `${user.firstname || ''} ${user.lastname || ''}`.trim();
                        const email = user.email || '';
                        const phone_number = user.phone || '';
                        setInitialValues(prev => ({
                            ...prev,
                            name,
                            email,
                            phone_number
                        }));
                    }
                } catch (err) {
                    console.error('Error fetching user info:', err);
                }
            };

            fetchUserDetails();
        }
    }, []);
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const res = await axios.post(Constants.addContact, values);
            if (res.data.status === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Thank you!',
                    text: 'Your message has been submitted.',
                });
                resetForm();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: res.data.message || 'Something went wrong.',
                });
            }
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Server error!',
                text: 'Please try again later.',
            });
        }
        setSubmitting(false);
    };

    return (
        <>
            <Breadcumb pagetitle="Contact Us" />
            <section className='py-12'>
                <div className='container mx-auto px-4'>
                    <Grid container spacing={1} className='justify-center'>
                        <Grid item lg={5}>
                            <div className='p-8 border'>
                                <div className='text-center mb-10'>
                                    <h2 className="text-4xl font-bold headningfont mb-4 text-center text-[#A27800]">Write Us</h2>
                                    <p className='mb-14 text-gray-600'>For all enquiries, please email us using the form below and we’ll get back to you as quickly as possible.</p>
                                </div>

                                <Formik
                                    initialValues={initialValues}
                                    enableReinitialize
                                    validationSchema={ContactSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ isSubmitting }) => (
                                        <Form>
                                            <div className='mb-5'>
                                                <Field
                                                    as={TextField}
                                                    label="Name"
                                                    name="name"
                                                    variant="outlined"
                                                    className='w-full rounded-lg'
                                                    fullWidth
                                                />
                                                <ErrorMessage name="name" component="div" className="text-red-500 text-sm mt-1" />
                                            </div>

                                            <div className='mb-5'>
                                                <Field
                                                    as={TextField}
                                                    label="Email"
                                                    name="email"
                                                    variant="outlined"
                                                    className='w-full rounded-lg'
                                                    fullWidth
                                                />
                                                <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
                                            </div>

                                            <div className='mb-5'>
                                                <Field
                                                    as={TextField}
                                                    label="Phone Number"
                                                    name="phone_number"
                                                    variant="outlined"
                                                    className='w-full rounded-lg'
                                                    fullWidth
                                                />
                                                <ErrorMessage name="phone_number" component="div" className="text-red-500 text-sm mt-1" />
                                            </div>

                                            <div className='mb-5'>
                                                <Field
                                                    as={TextField}
                                                    label="What’s on your mind?"
                                                    name="message"
                                                    variant="outlined"
                                                    multiline
                                                    rows={4}
                                                    className='w-full rounded-lg'
                                                    fullWidth
                                                />
                                                <ErrorMessage name="message" component="div" className="text-red-500 text-sm mt-1" />
                                            </div>

                                            <button
                                                type="submit"
                                                disabled={isSubmitting}
                                                className="w-full h-[54px] shadow-0 bg-[#A27800] rounded-full text-white font-semibold hover:bg-black transition-all"
                                            >
                                                {isSubmitting ? 'Submitting...' : 'Submit'}
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </section>
        </>
    );
}
